import { UNAVAILABLE_TABLE_VALUE } from '../constants/common';

export function jsonStringToObject(jsonString, defaultValue = '') {
  try {
    return JSON.parse(jsonString);
  } catch (error) {
    if (defaultValue) {
      return defaultValue;
    }

    throw error;
  }
}

export function getStockInRetailer({ availableInventory, permissions, inventoryBuffer, maxVisibleInventory }) {
  if (!permissions) {
    return UNAVAILABLE_TABLE_VALUE;
  }

  const isApproved = permissions[0]?.ecommerce_approved && permissions[0]?.ecommerce_approved_by_retailer;

  if (!isApproved) {
    return UNAVAILABLE_TABLE_VALUE;
  }

  // taken from cymbio-api-3 ObjectionModels/Variant.ts function getAvailableInventoryForRetailer
  const unlimitedStock = permissions[0]?.unlimited_stock;

  if (unlimitedStock) {
    return unlimitedStock;
  }

  const retailerInventory = Math.min(availableInventory - inventoryBuffer, maxVisibleInventory);

  return retailerInventory < 0 ? 0 : retailerInventory;
}

export async function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
